<mat-card>
    <mat-card-content class="px-5">
        <app-form-error class="d-block mb-3" [error]="error" />

        <form class="register-form" [formGroup]="form">
            <div class="phone-field-container">
                <app-country-selector [countryCodes]="countryCodes"
                                      [codeControl]="codeControl"
                                      (codeSelected)="onCodeSelect()" />

                <mat-form-field class="phone-field">
                    <input matInput
                           type="text"
                           [placeholder]="'app.form.labels.phoneNumber' | translate"
                           [imask]="{ mask: '000000000000' }"
                           maxlength="12"
                           minlength="5"
                           [formControlName]="'phone'"
                           #phoneInput
                           required
                           autocomplete="tel-national"
                    />

                    @if (phoneControl.hasError('required')) {
                        <mat-error translate>auth.errors.phone_required</mat-error>
                    }
                </mat-form-field>
            </div>

            @if (fields['email'] && fields['email'] !== 'U') {
                <mat-form-field class="email-field">
                    <input matInput
                           type="text"
                           [placeholder]="'app.form.labels.email' | translate"
                           [formControlName]="'email'"
                           [required]="fields?.email === 'M'"
                    />
                    @if (emailControl.hasError('required')) {
                        <mat-error translate>auth.errors.email_required</mat-error>
                    }
                    @if (emailControl.hasError('pattern')) {
                        <mat-error translate>auth.errors.email_invalid</mat-error>
                    }
                </mat-form-field>
            }


            @if (fields?.firstName && fields?.firstName !== 'U') {
                <mat-form-field class="name-field">
                    <input matInput
                           type="text"
                           [placeholder]="'app.form.labels.firstName' | translate"
                           [formControlName]="'name'"
                           [required]="fields?.firstName === 'M'"
                    />
                    @if (nameControl.hasError('pattern')) {
                        <mat-error translate>auth.errors.pattern</mat-error>
                    }
                    @if (nameControl.hasError('maxlength')) {
                        <mat-error>
                            {{ 'auth.errors.maxlength' | translate: { length: 150 } }}
                        </mat-error>
                    }
                    @if (nameControl.hasError('required')) {
                        <mat-error translate>auth.errors.name_required</mat-error>
                    }
                </mat-form-field>
            }

            @if (fields.lastName && fields?.lastName !== 'U') {
                <mat-form-field class="surname-field">
                    <input matInput
                           type="text"
                           [placeholder]="'app.form.labels.lastName' | translate"
                           [formControlName]="'surname'"
                           [required]="fields?.lastName === 'M'"
                    />
                    @if (surnameControl.hasError('pattern')) {
                        <mat-error translate>auth.errors.pattern</mat-error>
                    }
                    @if (surnameControl.hasError('maxlength')) {
                        <mat-error>{{ 'auth.errors.maxlength' | translate: { length: 150 } }}</mat-error>
                    }
                    @if (surnameControl.hasError('required')) {
                        <mat-error translate>auth.errors.surname_required</mat-error>
                    }
                </mat-form-field>
            }

            <mat-form-field class="password-field">
                <input matInput
                       [type]="hidePassword ? 'password' : 'text'"
                       [placeholder]="'app.form.labels.password' | translate"
                       [formControlName]="'password'"
                       minlength="8"
                       maxlength="255"
                       required
                       autocomplete="new-password"
                />

                <mat-icon matSuffix
                          (click)="hidePassword = !hidePassword"
                          class="hide-password-icon"
                          [fontIcon]="hidePassword ? 'visibility_off' : 'visibility'" />

                @if (passwordControl.hasError('required')) {
                    <mat-error translate>auth.errors.password_required</mat-error>
                }

                @if (passwordControl.hasError('minlength')) {
                    <mat-error>
                        {{ 'auth.errors.password_length'| translate: { length: passwordMinLength } }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field class="confirm-field">
                <input matInput
                       [type]="hidePassword ? 'password' : 'text'"
                       [placeholder]="'app.form.labels.confirmPassword' | translate"
                       [formControlName]="'confirmPassword'"
                       maxlength="255"
                       autocomplete="off"
                />
                @if (confirmControl.hasError('mismatch')) {
                    <mat-error translate>auth.errors.passwords_not_match</mat-error>
                }
            </mat-form-field>

            <mat-form-field class="region-field">
                <mat-select [placeholder]="'app.form.labels.homeRegion' | translate"
                            [formControlName]="'region'"
                            [disableOptionCentering]="true"
                            required>
                    @for (region of regions; track region.id) {
                        <mat-option [value]="region.id">{{ region.name }}</mat-option>
                    }
                </mat-select>
                @if (regionControl.hasError('required')) {
                    <mat-error translate>auth.errors.region_required</mat-error>
                }
            </mat-form-field>

            <div class="terms-check-field">
                <div>
                    <mat-checkbox [color]="'primary'"
                                  [aria-labelledby]="'agree_with_label'"
                                  [(ngModel)]="termsAccepted"
                                  [ngModelOptions]="{ standalone: true }" />

                    <span id="agree_with_label">{{ 'auth.register.agree_with' | translate }}</span>
                </div>

                <div class="terms-links">
                    <a [routerLink]="[routeEntity.Root, routeEntity.TermsOfUse]"
                       tabindex="0"
                       target="_blank"
                       class="a--border-off"
                       [attr.title]="navItemTranslateCodes.get(routeEntity.TermsOfUse) | translate">
                        {{ navItemTranslateCodes.get(routeEntity.TermsOfUse) | translate }}
                    </a>

                    <div translate>auth.register.terms_link_and</div>
                    <a target="_blank"
                       class="a--border-off"
                       [routerLink]="[routeEntity.Root, routeEntity.PrivacyPolicy]"
                       tabindex="0"
                       [attr.title]="navItemTranslateCodes.get(routeEntity.PrivacyPolicy) | translate">
                        {{ navItemTranslateCodes.get(routeEntity.PrivacyPolicy) | translate }}
                    </a>
                </div>
            </div>

            <div class="account-admin-method">
                <p>
                    <small [innerHTML]="channelsText?.message"></small>
                </p>
                <mat-form-field class="select-form-field">
                    <mat-select class="select" [placeholder]="'app.form.labels.communicationChannel' | translate"
                                [formControlName]="'sysCode'">
                        @for (channel of channels; track channel.chnlId) {
                            <mat-option [value]="channel.sysCode">
                                {{ channel.channelName }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="d-flex">
                <button class="mat-mdc-elevation-specific mat-elevation-z0"
                        color="primary"
                        mat-raised-button
                        type="submit"
                        [disabled]="form.invalid || pending || !termsAccepted"
                        (click)="onSubmit()">
                    {{ 'app.actions.createAccount' | translate }}
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
